<template>
    <span class="page-title">
        <i :class="icon" />
        <h1 v-if="!isEditing">
            {{ model ? model.name : "..." }}
        </h1>
        <InputText v-else-if="model" type="text" v-model="model.name" />
    </span>
</template>

<script lang="ts" setup>
import { useEditManager } from "@/composables/edit-manager";

const model = defineModel<{
    name: string;
}>();

defineProps<{
    icon: string;
}>();

const { isEditing } = useEditManager();
</script>

<style lang="scss" scoped>
.page-title {
    width: 100%;
    margin-bottom: 0;
    display: flex;
    margin-right: 0.5rem;
    gap: 0.5rem;

    i {
        line-height: 1.6em;
        font-size: 1.6rem;
        vertical-align: top;
    }

    .p-inputtext {
        flex: 1;
        font-size: var(--text-xxl);
        font-weight: bold;
        color: var(--text-color);
        padding: 0;
    }
}
</style>
